var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUkFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.435,
    height: 22.381,
    viewBox: "0 0 34.435 22.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UK-Flag",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11562",
    "data-name": "Path 11562",
    d: "M24.021,0,12.58,7.459H10L21.5,0H20.191L9.716,6.827V0H8.569V8.953h15.5V7.459H16.4L24.066,2.5V0Z",
    transform: "translate(10.369 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11563",
    "data-name": "Path 11563",
    d: "M14.347,0V6.827L3.876,0H0L11.507,7.459H8.926L0,1.642V2.5L7.662,7.459H0V8.953H15.494V0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11564",
    "data-name": "Path 11564",
    d: "M1.753,0,12.224,6.827V0Z",
    transform: "translate(2.122 0)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11565",
    "data-name": "Path 11565",
    d: "M0,0V1.642L8.924,7.459h2.581Z",
    transform: "translate(0 0)",
    fill: "#cf142b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11566",
    "data-name": "Path 11566",
    d: "M0,1.445V6.09H7.662L0,1.131Z",
    transform: "translate(0 1.368)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11567",
    "data-name": "Path 11567",
    d: "M9.088,0V6.827L19.561,0Z",
    transform: "translate(10.997 0)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11568",
    "data-name": "Path 11568",
    d: "M20.721,0,9.216,7.459H11.8L23.238,0Z",
    transform: "translate(11.151 0)",
    fill: "#cf142b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11569",
    "data-name": "Path 11569",
    d: "M12.113,6.092h7.664V1.13Z",
    transform: "translate(14.657 1.367)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11570",
    "data-name": "Path 11570",
    d: "M15.494,0V8.953H0v4.475H15.494v8.953h3.443V13.428h15.5V8.953h-15.5V0Z",
    transform: "translate(0 0)",
    fill: "#cf142b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11571",
    "data-name": "Path 11571",
    d: "M9.913,6.076H8.569v8.953H9.716V8.2l10.473,6.827h3.874l-11.5-7.461h2.581l8.92,5.819v-.857L16.4,7.568h7.662V6.076Z",
    transform: "translate(10.369 7.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11572",
    "data-name": "Path 11572",
    d: "M14.347,6.076H0V7.568H7.662L0,12.529v2.5L11.459,7.568H14.04L2.535,15.029H3.876L14.347,8.2v6.827h1.147V6.076Z",
    transform: "translate(0 7.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11573",
    "data-name": "Path 11573",
    d: "M1.753,13.865H12.224V7.038Z",
    transform: "translate(2.122 8.516)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11574",
    "data-name": "Path 11574",
    d: "M14.025,6.751H11.459L0,14.212H2.535L14.04,6.751Z",
    transform: "translate(0 8.169)",
    fill: "#cf142b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11575",
    "data-name": "Path 11575",
    d: "M0,6.751v4.961L7.662,6.751Z",
    transform: "translate(0 8.169)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11576",
    "data-name": "Path 11576",
    d: "M9.088,8.044v5.819H19.561L9.088,7.039Z",
    transform: "translate(10.997 8.516)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11577",
    "data-name": "Path 11577",
    d: "M12.936,6.751H10.376l11.5,7.461V12.57l-8.92-5.819Z",
    transform: "translate(12.556 8.169)",
    fill: "#cf142b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11578",
    "data-name": "Path 11578",
    d: "M12.113,6.751l7.664,4.961V6.751Z",
    transform: "translate(14.657 8.169)",
    fill: "#036"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/UK-Flag.7bd897c876da304c72a5503ebd7fa086.svg";
export { ForwardRef as ReactComponent };